(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4140],{

/***/ 24372:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.FU = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 37553:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'link';
var width = 640;
var height = 512;
var aliases = [128279,"chain"];
var unicode = 'f0c1';
var svgPathData = 'M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.nN = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 37050:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'location-dot';
var width = 384;
var height = 512;
var aliases = ["map-marker-alt"];
var unicode = 'f3c5';
var svgPathData = 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.op = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 82426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ About; }
/* harmony export */ });
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faLink__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(37553);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faEnvelope__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(24372);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faClock__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52699);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPhoneVolume__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(55083);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faLocationDot__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37050);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var layouts_LocationLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12424);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75046);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80819);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30120);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var lib_utils_calcOpenNow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95271);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(93024);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73582);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56513);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57731);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);


















var AMENITY_ICONS = {
  'amenities_Delivery': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faTruck */ .$KU,
  'amenities_Onsitepickup': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faBagShopping */ .Cdv,
  'amenities_Curbsidepickup': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCar */ .yn$,
  'amenities_Freeparking': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCircleParking */ .rL2,
  'amenities_Reservation': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCalendarCheck */ .Ry6,
  'amenities_Doctoronsite': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faUserDoctor */ .x3j,
  'amenities_Specialoffer': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faTag */ .LEN,
  'amenities_Accessible': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faWheelchair */ .woC,
  'amenities_Minimumage18': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faIdCard */ .Ukp,
  'amenities_Minimumage19': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faIdCard */ .Ukp,
  'amenities_Minimumage21': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faIdCard */ .Ukp,
  'amenities_ATM': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faMoneyBill */ .aLp,
  'amenities_AcceptCreditCard': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCreditCard */ .Ozh,
  'amenities_LabTested': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faFlask */ .jZZ,
  'amenities_Medical': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faHouseMedical */ .tp,
  'amenities_BrandVerified': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCertificate */ .Ua$,
  'amenities_Videos': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faVideo */ .IyC,
  'amenities_Security': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faLock */ .byT,
  'amenities_Photos': _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faImage */ .VmB
};




var MARKER = _data_config_json__WEBPACK_IMPORTED_MODULE_10__/* .map.marker */ .UI.Jw;
var __N_SSP = true;
function About(props) {
  var _location$amenities, _location$social, _location$social2, _location$social3, _location$social4, _location$social5;

  var location = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.location.location;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      openNow = _useState[0],
      setOpenNow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''),
      hoursToday = _useState2[0],
      setHoursToday = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      amenities = _useState3[0],
      setAmenities = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
    located: false,
    latitude: 0,
    longitude: 0
  }),
      geo = _useState4[0],
      setGeo = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      loaded = _useState5[0],
      setLoaded = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isMobile = _useState6[0],
      setIsMobile = _useState6[1];

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _calcOpenNow = (0,lib_utils_calcOpenNow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(location.business_hours, location.timezone),
        isOpen = _calcOpenNow.isOpen,
        openTime = _calcOpenNow.openTime,
        closeTime = _calcOpenNow.closeTime;

    setOpenNow(isOpen);
    setHoursToday("".concat(openTime, " - ").concat(closeTime));
    console.log('location: ', location);
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.locate)(setGeo);
    arrangeAmenities();
    setLoaded(true);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.checkMobile)());
    }
  }, [loaded]);

  var arrangeAmenities = function arrangeAmenities() {
    var allAmenities = _data_config_json__WEBPACK_IMPORTED_MODULE_10__/* .location.amenities */ .xh.ge;
    var ownedAmenitiesId = location.amenities;
    var amenitiesList = ownedAmenitiesId.map(function (item) {
      return allAmenities[Number(item) - 1];
    });
    setAmenities(amenitiesList.filter(function (item) {
      return !!item;
    }));
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
      className: isMobile ? 'flex flex-col' : 'flex gap-8 items-start',
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
        className: isMobile ? 'w-full order-2 mt-5' : 'w-7/12',
        children: [location.introduction && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
          className: 'mb-8',
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("h2", {
            className: 'font-bold mb-3',
            children: t('home:store_introduction')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("p", {
            children: location.introduction
          })]
        }), location.about && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
          className: 'mb-8',
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("h2", {
            className: 'font-bold mb-3',
            children: t('home:store_aboutUs')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("p", {
            children: location.about
          })]
        }), ((_location$amenities = location.amenities) === null || _location$amenities === void 0 ? void 0 : _location$amenities.length) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
          className: 'mb-8',
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("h2", {
            className: 'font-bold mb-6',
            children: t('home:store_amenities')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-[repeat(auto-fit,minmax(70px,1fr))] gap-6",
            children: amenities.length > 0 && amenities.map(function (a) {
              return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
                className: "text-center leading-tight text-gray-500",
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                  icon: AMENITY_ICONS[a.key],
                  className: "text-2xl"
                }), " ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("br", {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("span", {
                  className: "text-xs",
                  children: a.name
                })]
              }, a.key);
            })
          })]
        }), location.announcement && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
          className: 'mb-8',
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("h2", {
            className: 'font-bold mb-3',
            children: t('home:store_announcement')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("p", {
            children: location.announcement
          })]
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
        className: isMobile ? "w-full order-1 border rounded-md overflow-hidden " : "w-5/12 border rounded-md overflow-hidden ",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
          className: "relative overflow-hidden after:content-[''] after:pb-[56.25%] after:block",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("img", {
            src: "\n              https://maps.googleapis.com/maps/api/staticmap?zoom=17&size=640x360&markers=".concat(encodeURIComponent("color:blue|".concat(location.latitude, ",").concat(location.longitude)), "&key=AIzaSyAjKpb5fMYUxjqYLuCj5No8vhC9gXR3nKk\n            "),
            alt: '',
            className: "absolute inset-0 object-cover"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
          className: "p-6",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_pro_solid_svg_icons_faLocationDot__WEBPACK_IMPORTED_MODULE_15__/* .faLocationDot */ .op
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
              children: [location.address, " ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("br", {}), "".concat(location.city, ", ").concat(location.region, ", ").concat(location.country, ", ").concat(location.zip_code), " ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("br", {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("a", {
                href: geo.located ? "https://maps.google.com/maps/dir/".concat(geo.latitude, ",").concat(geo.longitude, "/").concat(location.latitude, ",").concat(location.longitude) : "https://www.google.com/maps/place/".concat(location.latitude, ",").concat(location.longitude),
                target: '_blank',
                rel: 'noreferrer',
                className: 'font-bold text-primary-dark',
                children: t('home:store_getDirection')
              })]
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_pro_solid_svg_icons_faPhoneVolume__WEBPACK_IMPORTED_MODULE_16__/* .faPhoneVolume */ .Eo
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("a", {
                href: "tel:".concat(location.phone_number),
                children: location.phone_number
              })
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_pro_solid_svg_icons_faClock__WEBPACK_IMPORTED_MODULE_17__/* .faClock */ .SZ
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
                className: 'mb-1',
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
                  className: "inline-block mr-4 w-28 font-bold text-primary-dark",
                  children: openNow ? t('home:openNow') : t('home:closed')
                }), hoursToday]
              }), ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(function (day) {
                return location.business_hours && location.business_hours.hasOwnProperty(day) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
                  className: 'mb-1',
                  children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
                    className: "inline-block mr-4 w-28",
                    children: lodash__WEBPACK_IMPORTED_MODULE_5___default().capitalize(day)
                  }), luxon__WEBPACK_IMPORTED_MODULE_4__/* .DateTime.fromFormat */ .ou.fromFormat(location.business_hours[day].open, 'hh:mma').toFormat('hh:mm a').toUpperCase(), ' - ', luxon__WEBPACK_IMPORTED_MODULE_4__/* .DateTime.fromFormat */ .ou.fromFormat(location.business_hours[day].close, 'hh:mma').toFormat('hh:mm a').toUpperCase()]
                }, day);
              })]
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_pro_solid_svg_icons_faEnvelope__WEBPACK_IMPORTED_MODULE_18__/* .faEnvelope */ .FU
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.isValidEmail)(location.email) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("a", {
                href: "mailto:".concat(location.email),
                children: location.email
              }) : null
            })]
          }), location.website && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_pro_solid_svg_icons_faLink__WEBPACK_IMPORTED_MODULE_19__/* .faLink */ .nN
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("a", {
                href: "".concat(location.website),
                target: '_blank',
                rel: 'noreferrer',
                children: t('home:visit_website')
              })
            })]
          }), ((_location$social = location.social) === null || _location$social === void 0 ? void 0 : _location$social.facebook) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faFacebookF */ .AYu
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("a", {
                href: "https://facebook.com/".concat(location.social.facebook),
                target: '_blank',
                rel: 'noreferrer',
                children: ["@", location.social.facebook]
              })
            })]
          }), ((_location$social2 = location.social) === null || _location$social2 === void 0 ? void 0 : _location$social2.instagram) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faInstagram */ .Zzi
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("a", {
                href: "https://instagram.com/".concat(location.social.instagram),
                target: '_blank',
                rel: 'noreferrer',
                children: ["@", location.social.instagram]
              })
            })]
          }), ((_location$social3 = location.social) === null || _location$social3 === void 0 ? void 0 : _location$social3.twitter) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faTwitter */ .mdU
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("a", {
                href: "https://twitter.com/".concat(location.social.twitter),
                target: '_blank',
                rel: 'noreferrer',
                children: ["@", location.social.twitter]
              })
            })]
          }), ((_location$social4 = location.social) === null || _location$social4 === void 0 ? void 0 : _location$social4.linkedin) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faLinkedinIn */ .hwn
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("a", {
                href: "https://linkedin.com/".concat(location.social.linkedin),
                target: '_blank',
                rel: 'noreferrer',
                children: ["@", location.social.linkedin]
              })
            })]
          }), ((_location$social5 = location.social) === null || _location$social5 === void 0 ? void 0 : _location$social5.youtube) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("section", {
            className: "flex items-start gap-3 mb-4",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              className: 'w-7 text-xl text-gray-500 translate-y-0.5',
              icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faYoutube */ .opf
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("a", {
                href: "https://youtube.com/".concat(location.social.youtube),
                target: '_blank',
                rel: 'noreferrer',
                children: ["@", location.social.youtube]
              })
            })]
          })]
        })]
      })]
    })
  });
}

About.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(layouts_LocationLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: page
    })
  });
};

/***/ }),

/***/ 99723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[locationSlug]/[id]/about",
      function () {
        return __webpack_require__(82426);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3714,5726,4909,2531,120,7607,2424,9774,2888,179], function() { return __webpack_exec__(99723); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);